import { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { moderatorSearch } from "../../api/index";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentDetailsModal from "../StudentDetailsModal";

export default function ModeratorSearch() {
  const user = JSON.parse(localStorage.getItem("profile")).value[0];
  const [search, setSearch] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    setLoading(true);
    setError("");
    setResults(null);
    setSelectedStudent(null);
    try {
      const { data } = await moderatorSearch(search.trim());
      if (data.students && data.students.length > 0) {
        setResults(data.students);
      } else {
        setError("No completed students found.");
      }
    } catch (err) {
      setError("Search failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (user.role !== "moderator") {
    return <UNAUTHORIZED />;
  }

  return (
    <>
    {selectedStudent && (
      <StudentDetailsModal
        student={selectedStudent}
        onClose={() => setSelectedStudent(null)}
        hideSections={["Status and Finance"]}
      />
    )}
    <div className="min-h-screen px-4 sm:px-8 py-6">
      <div className="mb-8 flex items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-purple-600/20 border border-purple-500/30 flex items-center justify-center shrink-0">
          <FiSearch className="text-purple-400 text-xl" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Student Lookup</h1>
          <p className="text-slate-400 text-sm mt-0.5">Search by passport number or unique ID</p>
        </div>
      </div>

      <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 shadow max-w-xl">
        <form onSubmit={handleSearch} className="flex gap-3">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Passport number or Unique ID..."
            className="flex-1 bg-slate-800 border border-slate-600 text-white text-sm rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <button
            type="submit"
            disabled={loading || !search.trim()}
            className="flex items-center gap-2 bg-purple-600 hover:bg-purple-500 disabled:bg-gray-600 text-white text-sm font-semibold px-6 py-3 rounded-lg transition-colors shadow"
          >
            <FiSearch size={14} />
            {loading ? "Searching..." : "Search"}
          </button>
        </form>

        {error && (
          <div className="mt-4 p-4 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm">
            {error}
          </div>
        )}

        {results && results.length > 0 && (
          <div className="mt-6 space-y-3">
            <h3 className="text-slate-400 text-xs font-semibold uppercase tracking-widest">
              Results ({results.length})
            </h3>
            {results.map((student, i) => (
              <div
                key={student.passport_number || i}
                onClick={() => setSelectedStudent(student)}
                className="p-4 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 cursor-pointer transition-all"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-white font-semibold">{student.full_name}</p>
                    <p className="text-slate-400 text-sm">Unique ID: {student.unique_id} | Passport: {student.passport_number}</p>
                  </div>
                  <span className="text-xs bg-emerald-500/20 text-emerald-400 px-2 py-1 rounded-full">
                    {student.state}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    </>
  );
}
